// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { displayNumber, displayPercent } from 'common/components/Number';
import { Colors, Metrics } from '../../../../themes';
import AntennaReach from '../../../../domain/AntennaReach';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const Metric = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${Metrics.margin}px;
`;

const MetricTitle = styled.div`
  margin-bottom: 8px;
  color: ${Colors.primaryText};
`;

const MetricNumber = styled.div`
  color: ${Colors.primary};
  font-size: ${Metrics.numeric.mediumMetric}px;
  margin: 0px;
`;

interface Props {
  antennaReach: AntennaReach;
  t: any;
}

function GeolocalisationAntennaReach({ antennaReach, t }: Props) {
  return (
    <Wrapper>
      <Metric>
        <MetricTitle>{t('insideAntennaReach')}</MetricTitle>
        <MetricNumber>{displayNumber(antennaReach.reachInsideAntenna)} ({displayPercent(antennaReach.proportionInsideAntenna)})</MetricNumber>
        <p>{t('betaFeature')}</p>
      </Metric>
    </Wrapper>
  );
}

export default translate('dashboard')(withTheme(GeolocalisationAntennaReach));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/components/geolocalisation/GeolocalisationAntennaReach.js